import React from 'react';
import QRCode from 'qrcode.react';

import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import FullScreenDialog, { FullScreenDialogProps } from '../FullScreenDialog';
import useCompanyContext from '../../hooks/useCompanyContext';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: theme.spacing(6),
  },
  logoContainer: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  merchantLogo: {
    height: 120,
    width: 120,
    borderRadius: '50%',
    objectFit: 'cover',
    boxShadow: '0 2px 10px rgba(199, 199, 199, 0.5)',
  },
  header: {
    marginTop: theme.spacing(2),
    textAlign: 'center',
  },
  qr: {
    margin: theme.spacing(3),
  },
  box: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
  },
  close: {
    marginRight: 'auto',
  },
  closeIcon: {
    color: theme.palette.common.black,
  },
}));

type Props = Pick<FullScreenDialogProps, 'open'> & {
  onClose: () => void;
};

export default function JoiningCodeDialog({ open, onClose }: Props) {
  const classes = useStyles();
  const { company } = useCompanyContext();

  if (!company) {
    return null;
  }

  return (
    <FullScreenDialog open={open}>
      <div className={classes.box}>
        <div className={classes.close}>
          <IconButton onClick={onClose}>
            <CloseIcon className={classes.closeIcon} />
          </IconButton>
        </div>
      </div>
      <div className={classes.logoContainer}>
        <img
          src={company.logo?.versions.xl}
          className={classes.merchantLogo}
          alt="flex reward"
        />
        <Typography variant="h4" className={classes.header}>
          {company.name.toUpperCase()}
        </Typography>
        <div className={classes.qr}>
          <QRCode
            value={company.applink}
            size={350}
            renderAs="svg"
            includeMargin
          />
        </div>
        <Typography variant="h4" className={classes.header}>
          SCAN TO JOIN
        </Typography>
      </div>
    </FullScreenDialog>
  );
}
